import { ConfirmModal } from "@components/index";

export const DeleteTransactionConfirmModal = ({
  show,
  onClickCancel,
  onClickConfirm,
}: {
  show: boolean;
  onClickCancel: () => void;
  onClickConfirm: () => void;
}) => (
  <ConfirmModal
    show={show}
    confirmButtonTitle="Delete"
    text1="Are you sure?"
    text2="Do you really want to delete this transaction?"
    onClickCancel={onClickCancel}
    onClickConfirm={onClickConfirm}
  />
);
